import ar from "./ar";
import de from "./de";
import en from "./en";
import es from "./es";
import fa from "./fa";
import fr from "./fr";
import it from "./it";
import ja from "./ja";
import ru from "./ru";
import tr from "./tr";

export const RTL_LANGUAGE_CODES = new Set(["ar", "fa"]);

export const normalizeLanguageCode = (languageCode = "en") => (
    languageCode
        .toLowerCase()
        .split(/[-_]/)[0]
);

export const isRtlLanguage = (languageCode = "en") => RTL_LANGUAGE_CODES.has(
    normalizeLanguageCode(languageCode)
);

export const TRANSLATION_RESOURCES = {
    ar: { translation: ar },
    de: { translation: de },
    en: { translation: en },
    es: { translation: es },
    fa: { translation: fa },
    fr: { translation: fr },
    it: { translation: it },
    ja: { translation: ja },
    ru: { translation: ru },
    tr: { translation: tr },
};
